export default __webpack_public_path__ + "static/media/THERMAL_TREATMENT.01caede2.png";